$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");

  if (p === "events") {
    let locationId = $("#classic-location-products").attr("data-location-id");
    let skeletonHtml = $("#tripleTaxInvoicesModal").html();

    $(document).on("submit", ".tripleTexInvoicesFilterForm", function (e) {
      e.preventDefault();
      const filterSubmitButton = $(this).find('button[type="submit"]');
      const originalButtonText = filterSubmitButton.text();
      const originalButtonWidth = filterSubmitButton.outerWidth();
      filterSubmitButton.html(
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>',
      );
      filterSubmitButton.css("width", originalButtonWidth + "px");
      filterSubmitButton.prop("disabled", true);

      const dateFrom = $("#start_date").val();
      const dateTo = $("#end_date").val();

      $.ajax({
        url: "/api/v1/tripletex/invoices",
        method: "POST",
        data: {
          locationId: locationId,
          dateFrom: dateFrom,
          dateTo: dateTo,
        },
      })
        .done(function (response) {
          if (response.modalHtml) {
            $("#tripleTaxInvoicesModal").html(response.modalHtml);
          } else {
            alert("Ingen fakturaer tilgjengelig.");
          }
          filterSubmitButton.html(originalButtonText);
          filterSubmitButton.prop("disabled", false);
        })
        .fail(function () {
          filterSubmitButton.html(originalButtonText);
          filterSubmitButton.prop("disabled", false);
          alert("Feil ved innlastning av fakturaer.");
        });
    });

    $(document).on("submit", ".tripleTexInvoicesSearchForm", function (e) {
      e.preventDefault();

      let searchString = $("#search-string").val().toLowerCase();
      $("#tripleTexInvoicesTable tbody tr").filter(function () {
        let invoiceNumber = $(this).find("td:eq(0)").text().toLowerCase();
        let customerName = $(this).find("td:eq(2)").text().toLowerCase();
        let customerNumber = $(this).find("td:eq(3)").text().toLowerCase();

        let match =
          invoiceNumber.includes(searchString) ||
          customerName.includes(searchString) ||
          customerNumber.includes(searchString);

        $(this).toggle(match);
      });
      filterInvoices(searchString);
    });

    // Show/hide × button as user types
    $(document).on("input", "#search-string", function () {
      $("#clear-search").toggle($(this).val().length > 0);
    });

    // Clear input and reset table on × click
    $(document).on("click", "#clear-search", function () {
      $("#search-string").val("");
      $(this).hide();
      $("#tripleTexInvoicesTable tbody tr").show();
      filterInvoices("");
    });

    $(document).on("click", "#tripleTexInvoicesTable .sort", function () {
      const table = $("#tripleTexInvoicesTable");
      const rows = table.find("tbody tr").get();
      const index = $(this).index();
      const isAsc = $(this).attr("data-order-by-direction") === "asc";
      const icons = table.find(".material-icons");
      icons.addClass("d-none");
      const icon = $(this).find(".material-icons");
      icon.removeClass("d-none");

      if (isAsc) {
        $(this).attr("data-order-by-direction", "desc");
        icon.addClass("material-icons-asc");
      } else {
        $(this).attr("data-order-by-direction", "asc");
        icon.removeClass("material-icons-asc");
      }

      rows.sort(function (a, b) {
        const A = $(a).children("td").eq(index).text().toUpperCase();
        const B = $(b).children("td").eq(index).text().toUpperCase();
        if (A < B) {
          return isAsc ? -1 : 1;
        }
        if (A > B) {
          return isAsc ? 1 : -1;
        }
        return 0;
      });

      $.each(rows, function (index, row) {
        table.children("tbody").append(row);
      });
    });

    $(document).on("click", "#tripletex-payment-cancel", function (e) {
      $("#tripletex-payment-amount-modal").modal("hide");
    });

    $(document).on(
      "hidden.bs.modal",
      "#tripletex-payment-amount-modal",
      function () {
        if ($("#tripleTaxInvoicesModal").hasClass("show")) {
          $("body").addClass("modal-open");
        }
      },
    );

    $(document).on("hidden.bs.modal", "#tripleTaxInvoicesModal", function (e) {
      if (e.target.id !== "tripleTaxInvoicesModal") return;
      $(this).html(skeletonHtml);
    });

    $(document).on("click", "#tripletex-invoices-button", function () {
      $("#tripleTaxInvoicesModal").modal("show");
      $.ajax({
        url: "/api/v1/tripletex/invoices",
        method: "POST",
        data: {
          locationId: locationId,
        },
      })
        .done(function (response) {
          if (response.modalHtml) {
            $("#tripleTaxInvoicesModal").html(response.modalHtml);
          } else {
            alert("Ingen fakturaer tilgjengelig.");
          }
        })
        .fail(function () {
          alert("Feil ved innlastning av fakturaer.");
        });
    });

    function filterInvoices(q) {
      $(".invoice-card").each(function () {
        const num = $(this).data("invoice-number").toString();
        const name = $(this).data("customer-name").toLowerCase();
        const custNo = $(this).data("customer-number").toString();

        $(this).toggle(
          num.includes(q) || name.includes(q) || custNo.includes(q),
        );
      });
    }
  }
});
